// removed by extract-text-webpack-plugin
module.exports = {"deviceList":"deviceList__1Nuj1","checkbox":"checkbox__2CrbN","searchable":"searchable__3XVE2","pager":"pager__2ha1d","pagers":"pagers__2IvZV","devices":"devices__3anDF","noDevice":"noDevice__2hspO","newDevice":"newDevice__2P9Ig","deleting":"deleting__2UjZC","deleted":"deleted__2nh5Z","marginT":"marginT__2wfNf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/DeviceList/styles.scss
// module id = 2204
// module chunks = 1